import { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, EffectFade, Scrollbar } from 'swiper'
import { Box } from '@mui/material'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'
import 'swiper/css/scrollbar'

import { SlideType } from '../../../../_types'
import { CarouselSlide } from './CarouselSlide'

export interface CarouselSlideSelectorProps {
  slides: SlideType[]
  slidesPerView?: number
  activeIndex?: number
  onSlideSelect: any
  onSwiper?: any
}
export const CarouselSlideSelector: React.FC<CarouselSlideSelectorProps> = ({
  slides,
  onSwiper,
  slidesPerView = 4,
  activeIndex,
  onSlideSelect,
}) => {
  const scrollRef = useRef(null)
  return (
    <>
      <Swiper
        className="CarouselSlideSelector"
        modules={[Navigation, EffectFade, Scrollbar]}
        navigation={true}
        simulateTouch={false}
        slidesPerView={slidesPerView}
        onSwiper={onSwiper}
        style={{ width: '100%', userSelect: 'none' }}
        scrollbar={{ draggable: true, el: scrollRef.current, dragSize: 150 }}
        initialSlide={activeIndex}
      >
        {slides?.map((s: SlideType, i: number) => {
          return (
            <SwiperSlide
              key={i}
              style={{
                cursor: 'pointer',
              }}
            >
              <CarouselSlide
                slide={s}
                isActiveSlide={activeIndex === s?.index}
                onSlideSelect={onSlideSelect}
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
      <Box
        ref={scrollRef}
        sx={{ width: '100%', backgroundColor: '#ededeb', height: '14px' }}
      />
    </>
  )
}

export default CarouselSlideSelector
